import PGALTable from "../common/PGALTable";

const PlayoffLeaderboard = ({ headers, rows, title, color = "tertiary" }) => {
    return (
        <PGALTable
            title={title}
            color={color}
            headers={headers}
            rows={rows}
        />
    );
};

export default PlayoffLeaderboard;